import { useCallback } from 'react';

import type { RootState } from '@/store';
import { useAppDispatch, useAppSelector } from '@/store';
import { clearPollingModal } from '@/store/slices/ui/uiSlice';

export function useGlobalPollingModal() {
  const dispatch = useAppDispatch();
  const { pollingModal } = useAppSelector((state: RootState) => state.ui);

  const isOpen = pollingModal.type !== null && pollingModal.type !== 'success';

  const handleClose = useCallback(() => {
    dispatch(clearPollingModal());
  }, [dispatch]);

  return {
    state: {
      isOpen,
      title: pollingModal.title,
      message: pollingModal.message,
      details: pollingModal.details,
    },
    handlers: {
      handleClose,
    },
  };
}
